import { useRouter } from 'next/router';

import { useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import { useMultiplexBuildingSessionId } from './useMultiplexBuildingSessionId';

export const useMultiplexUnitPublished = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string | undefined;
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const { data, error, isFetching } = useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished(
    {
      multiplexBuildingSessionId: multiplexBuildingSessionId ?? '',
      listingAlias: listingAlias ?? '',
    },
    {
      enabled: enabled && Boolean(multiplexBuildingSessionId && listingAlias),
      meta: {
        tags: ['multiplexUnitPublished', multiplexBuildingSessionId ?? '', listingAlias ?? ''],
        context: {
          api: 'useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished',
          details: 'useMultiplexUnitPublished',
        },
      },
    },
  );

  return { data, isFetching, error };
};
